// removed by extract-text-webpack-plugin
module.exports = {"socialLoginButton":"GoogleLoginButton__socialLoginButton","googleButton":"GoogleLoginButton__googleButton","growDotQello":"GoogleLoginButton__growDotQello","growDotBlue":"GoogleLoginButton__growDotBlue","growDotGolden":"GoogleLoginButton__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/GoogleLoginButton/GoogleLoginButton.scss
// module id = 1853
// module chunks = 0